/**
 * CPA Template — Navigation Configuration
 *
 * Sidebar structure for the cpa skin.
 * Kept in the template boundary so template-specific UI structure stays
 * isolated from shared runtime config.
 */

export const sidebar = [
    {
        key: "home",
        exact: true,
        icon: "offers",
    },
    {
        key: "goals",
        nameKey: "offerings",
        icon: "home",
        href: "/offers/goals",
    },
    {
        key: "statistics",
        icon: "statistics",
        href: "/statistics/report",
        subMenu: [
            {
                key: "reportByDay",
                href: "/statistics/report-by-day",
                exact: true
            },
            {
                key: "reportByCountry",
                href: "/statistics/report-by-country",
                exact: true
            },
            {
                key: "reportByUTM",
                href: "/statistics/report-by-utm",
                exact: true
            },
            {
                key: "reportByCreative",
                href: "/statistics/report-by-creative",
                exact: true
            },
            {
                key: "reportByReferer",
                href: "/statistics/report-by-referer",
                exact: true
            },
            {
                key: "reportByReactivation",
                href: "/statistics/report-by-reactivation",
                exact: true
            },
            {
                key: "reportByReferral",
                href: "/statistics/report-by-referral",
                exact: true
            },
            {
                key: "report",
                href: "/statistics/report",
                exact: true
            },
            {
                key: "conversions",
                href: "/statistics/conversions",
            },
        ],
    },
    {
        key: "finance",
        icon: "finance",
        href: "/office/finances",
        subMenu: [
            {
                key: "payout",
                nameKey: "payments",
                href: "/office/finances/payout",
            },
            {
                key: "historyFinance",
                nameKey: "operationsHistory",
                href: "/office/finances/history",
            },
        ],
    },
    {
        key: "instruments",
        href: "/postback",
        icon: "instruments",
        subMenu: [
            {
                key: "postbacks",
                nameKey: "postback",
                href: "/postback/list",
            },
            {
                key: "historyPostback",
                nameKey: "postbackHistory",
                href: "/postback/history",
            },
        ],
    },
    {
        key: "information",
        href: "/office/settings/information",
        icon: "information",
    },
];
